import { Box, Stack, Typography } from "@mui/material";

import type { ActivationPageProps } from "../types";

export function PasswordResetPage(props: ActivationPageProps) {
  const { passwordField, submitButton, errorMessage } = props;

  return (
    <Box>
      <Typography textAlign="center" variant="h4" fontWeight="bold">
        Reset Your Password
      </Typography>
      <Stack my="2rem" spacing={2}>
        {passwordField}
        {errorMessage}
        {submitButton}
      </Stack>
    </Box>
  );
}
